import { initPreview } from './recorderpreview.js';
import { setupControls } from './recordercontrols.js';
import { closeModal } from './recorderclose.js';
import { loadSelfieSegmentationLibs } from './selfiesegmentationlib.js';
import { uploadRecording } from './uploadrecording.js';

/**
 * Punto de entrada principal del grabador
 * @param {'audio'|'video'} type - tipo de grabación
 * @param {Function} onAttach - callback para adjuntar el archivo
 * @param {Object} editor - instancia del editor CKEditor
 * @param {Object} fpoptions - opciones adicionales del filepicker
 */
export function openRecorderModal(type, onAttach, editor, fpoptions = {}) {

    // --- Eliminar modales previos si existieran ---
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const oldModal = document.getElementById('recordPreviewModal');
    if (oldModal) oldModal.remove();

    // --- Estructura base del modal ---
    const modalHtml = `
    <div class="modal fade moodle-has-zindex show" id="recordPreviewModal" tabindex="-1" role="dialog" style="display:block;" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content modal-contentwk">
                <div class="modal-header modal-headerwk">
                    <h3 class="modal-title wk-h3">Grabador de ${type}</h3>
                    <button type="button" class="closewk p-0 m-r-0 iconPcolor" id="closeRecordingBtn">
                        <i class="fas fa-times-circle iconPcolor"></i>
                    </button>
                </div>
                <div class="modal-body modal-bodywk">
                    <div id="recordPreviewArea" class="mb-3" style="position:relative;">
                        <p>Activando ${type === 'audio' ? 'micrófono' : 'cámara'}...</p>
                    </div>
                </div>
                <div class="modal-footer modal-footerwk">
                    <div class="d-flex justify-content-between">
                        <div class="w-100" id="recorderButtonsContainer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;
    const backdropHtml = `<div class="modal-backdrop fade show"></div>`;

    // Insertar modal y fondo
    document.body.insertAdjacentHTML('beforeend', modalHtml + backdropHtml);

    const modal = document.getElementById('recordPreviewModal');
    const previewArea = document.getElementById('recordPreviewArea');
    const timerEl = document.getElementById('recordTimer');
    const closeBtn = document.getElementById('closeRecordingBtn');

    // Inicializar vista previa (cámara o micrófono)
    initPreview(type, previewArea, () => {
        // Una vez lista la vista previa, se configuran los controles
        setupControls({
            type,
            modal,
            previewArea,
            timerEl,
            onAttach,
            fpoptions,
            loadSelfieSegmentationLibs,
            uploadRecording,
            closeModal
        });
    });

    // Botón de cierre
    if (closeBtn) closeBtn.onclick = closeModal;
}
